import { RDSaudeBlack } from '../../assets/rd-saude/black'
import { RDSaudeColored } from '../../assets/rd-saude/colored'
import { RDSaudeDarkGreen } from '../../assets/rd-saude/dark-green'
import { RDSaudeLightGreen } from '../../assets/rd-saude/light-green'
import { RDSaudeWhite } from '../../assets/rd-saude/white'
import { RDSaudeYellow } from '../../assets/rd-saude/yellow'
import { LogoWhithoutVariant } from '../without-variants'

export const logos = {
  white: {
    large: <RDSaudeWhite width={172} height={48} />,
    huge: <RDSaudeWhite width={258} height={64} />,
    enormous: <RDSaudeWhite width={344} height={80} />,
  },
  black: {
    large: <RDSaudeBlack width={172} height={48} />,
    huge: <RDSaudeBlack width={258} height={64} />,
    enormous: <RDSaudeBlack width={344} height={80} />,
  },
  colored: {
    large: <RDSaudeColored width={172} height={48} />,
    huge: <RDSaudeColored width={258} height={64} />,
    enormous: <RDSaudeColored width={344} height={80} />,
  },
  'light-green': {
    large: <RDSaudeLightGreen width={172} height={48} />,
    huge: <RDSaudeLightGreen width={258} height={64} />,
    enormous: <RDSaudeLightGreen width={344} height={80} />,
  },
  'dark-green': {
    large: <RDSaudeDarkGreen width={172} height={48} />,
    huge: <RDSaudeDarkGreen width={258} height={64} />,
    enormous: <RDSaudeDarkGreen width={344} height={80} />,
  },
  yellow: {
    large: <RDSaudeYellow width={172} height={48} />,
    huge: <RDSaudeYellow width={258} height={64} />,
    enormous: <RDSaudeYellow width={344} height={80} />,
  },
  'light-blue': {
    large: <LogoWhithoutVariant />,
    huge: <LogoWhithoutVariant />,
    enormous: <LogoWhithoutVariant />,
  },
  'dark-blue': {
    large: <LogoWhithoutVariant />,
    huge: <LogoWhithoutVariant />,
    enormous: <LogoWhithoutVariant />,
  },
  'light-orange': {
    large: <LogoWhithoutVariant />,
    huge: <LogoWhithoutVariant />,
    enormous: <LogoWhithoutVariant />,
  },
  'dark-orange': {
    large: <LogoWhithoutVariant />,
    huge: <LogoWhithoutVariant />,
    enormous: <LogoWhithoutVariant />,
  },
}
